import { createFileRoute } from '@tanstack/react-router';

import { CanvasPage } from '@/features/canvas';

export const Route = createFileRoute('/app/canvas')({
  component: CanvasPage,
});
